import { useEffect, useRef, useState } from 'react';

const faqs = [
  {
    question: 'Entrupy AI 驗真的準確率有多高？',
    answer: 'Entrupy AI 是國際認證的奢侈品鑑定技術，準確率達 99.1%。我們使用專業儀器拍攝微觀紋理，透過 AI 演算法比對數百萬筆真品數據，為您提供科學憑證。',
  },
  {
    question: '鑑定需要多久時間？',
    answer: '線上圖片初判通常在 24 小時內完成；實物鑑定則需 3-5 個工作天，視檢測項目而定。急件服務可於預約時告知，我們將優先處理。',
  },
  {
    question: '如何確保鑑定結果的公正性？',
    answer: '我們採用「三重驗證」機制：Entrupy AI 儀器驗真、Legit App 技術驗證，以及符合中檢標準的實驗室檢測。所有流程透明化，並提供詳細報告與證書。',
  },
  {
    question: '購買的裸石是否提供證書？',
    answer: '是的。炅白 Jiong Bai 系列採用「雙重證書策略」：源頭證書 + 台灣權威實驗室證書，確保您的資產保值。映白 Ying Bai 系列則提供透明規格說明與鑑定師簽名證明。',
  },
  {
    question: '如果鑑定結果有爭議怎麼辦？',
    answer: '我們支持全國任何權威機構複檢，並提供「假一賠三」保障。若複檢結果與我們的鑑定不符，我們將全額退款並賠償三倍金額。',
  },
  {
    question: '可以只做線上圖片鑑定嗎？',
    answer: '可以。我們提供線上圖片初判服務（$399 起），適合買前避雷。但若需要法律效力的正式證書，建議選擇實物鑑定服務。',
  },
];

export default function FaqSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-28 lg:py-36 bg-white overflow-hidden">
      {/* Background Text */}
      <div className="absolute top-8 left-0 pointer-events-none select-none overflow-hidden">
        <span className="block font-heading text-[10rem] lg:text-[18rem] leading-none text-black/[0.02] tracking-wider">
          FAQ
        </span>
      </div>

      <div className="relative max-w-[1000px] mx-auto px-6 lg:px-16">
        {/* Header */}
        <div className={`text-center mb-20 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-10 h-px bg-black"></div>
            <span className="text-[11px] font-body font-medium tracking-[0.25em] text-neutral-500 uppercase">
              Frequently Asked Questions
            </span>
            <div className="w-10 h-px bg-black"></div>
          </div>
          <h2 className="font-heading text-5xl lg:text-7xl text-black leading-[0.95] tracking-wide">
            常見問題
          </h2>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border border-neutral-200 bg-neutral-50 hover:bg-white transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${200 + index * 100}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left cursor-pointer group"
              >
                <div className="flex items-center gap-4 flex-1">
                  <span className="font-heading text-xl text-neutral-400 group-hover:text-black transition-colors">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="font-body text-[15px] text-black font-semibold">
                    {faq.question}
                  </h3>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-black transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6 pl-20">
                  <p className="font-body text-[14px] text-neutral-700 leading-[1.8]">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
